<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        sort-by="name"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col cols="3">
                <div class="d-flex align-center">
                  <span class="mr-3">
                    Filtros:
                  </span>
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="range"
                        label="Rango de fechas"
                        prepend-icon="mdi-calendar"
                        readonly
                        hide-details
                        dense
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      :range="true"
                      first-day-of-week="1"
                      :max="untilToday"
                      no-title
                    >
                      <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                      <v-spacer/>
                      <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                      <v-btn :disabled="dates.length < 2" color="primary" @click="filterByDate">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
          </div>
        </template>
         <template v-slot:item.amountAvailable="{ item }">
          {{ item.amountAvailable | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
        <template v-slot:item.amountWithheld="{ item }">
          {{ item.amountWithheld | toFixNumber(2) | numberWithComma | prefix('$') }}
        </template>
        <template v-slot:item.firstBalance="{ item }">
          {{ item.firstBalance.balanceAmount | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template><template v-slot:item.lastBalance="{ item }">
          {{ (item.lastBalance || {} ).kind === 'outgoing' ? (item.lastBalance || {}).balanceAmount - (item.lastBalance || {}).amount : (item.lastBalance || {}).balanceAmount + (item.lastBalance || {}).amount | toFixNumber(2) | numberWithComma  | prefix('$') }}
        </template>
      </v-data-table>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import Balance from '@/models/Balance'
import moment from 'moment'

export default {
  name: 'My-restaurants',
  data () {
    let balance = new Balance()

    return {
      overlay: false,
      datePicker: false,
      dates: [],
      section: this.$i18n.t('myRestaurants.section'),
      balance,
      table: {
        title: this.$i18n.t('myRestaurants.loading'),
        loading: true,
        headers: [
          { text: this.$i18n.t('myRestaurants.headers.restaurant'), value: 'restaurant', sortable: false },
          { text: this.$i18n.t('myRestaurants.headers.amountAvailable'), value: 'amountAvailable', sortable: false },
          { text: this.$i18n.t('myRestaurants.headers.amountWithheld'), value: 'amountWithheld', sortable: false },
          { text: this.$i18n.t('myRestaurants.headers.initialAmount'), value: 'firstBalance', sortable: false },
          { text: this.$i18n.t('myRestaurants.headers.lastAmount'), value: 'lastBalance', sortable: false }
        ],
        data: [],
        total: 1,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      }
    }
  },
  computed: {
    permissions () {
      return this.$store.state.login.permissions['my-management'].components['add-balance'].actions
    },
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    untilToday () {
      return moment().format('YYYY-MM-DD')
    }
  },
  mounted: async function () {
    this.balance.set({ restaurant: this.restaurant })
    const { response } = await this.balance.detail()
    this.balance.set({ restaurant: this.restaurant, ...response.data })
  },
  methods: {
    async resetDate () {
      this.dates = []
      await this.load()
      this.datePicker = false
    },
    async filterByDate () {
      this.dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      const dates = {}
      if (this.dates.length) {
        dates['createdAt>'] = this.$moment(this.dates[0]).startOf('day').toISOString()
        dates['createdAt<'] = this.$moment(this.dates[1]).endOf('day').toISOString()
      }
      const params = {
        ...dates
      }
      await this.load(params)
      this.datePicker = false
    },
    updateTable: async function (data) {
      this.table.options = data
      if (this.$store.state.area) {
        await this.load({
          limit: data.itemsPerPage,
          skip: (data.itemsPerPage * (data.page - 1))
        })
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
      }

      if (!params['createdAt>']) {
        params['createdAt>'] = this.$moment(this.dates[0]).startOf('month').toISOString()
        params['createdAt<'] = this.$moment(this.dates[1]).endOf('month').toISOString()
      }

      this.table.loading = true
      try {
        const response = await this.$api.get('/v1/my-restaurants', params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    }
  }
}
</script>
